import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const SliderCard = ({ location, index }) => {
  return (
    <div className="w-full px-1 md:px-[25px] group" key={index}>
      <div className="max-w-[360px] w-full flex flex-col mx-auto font-dinnext">
        <Link
          to={`/locations/${location.slug.current}`}
          className="mt-3 sm:mt-[26px] md:px-0 flex flex-col items-center text-center"
        >
          <div className="mb-5">
            <GatsbyImage
              image={location.shopImage.asset.gatsbyImageData}
              alt={location.shopImage.alt || location.title}
              objectFit="cover"
              className="w-full h-80 object-cover rounded-lg overflow-hidden"
            />
          </div>
          <h3 className="text-xl sm:text-3xl font-bold mb-3">
            {location.title}
          </h3>
          {/* <span
            className={`transition-colors ease-linear duration-150 min-w-[187px] h-11 text-center px-4 py-3 text-lg border
            border-solid flex items-center justify-center bg-transparent text-secondary border-secondary hover:bg-secondary hover:text-white`}
          >
            <span>See Details</span>
          </span> */}
        </Link>
      </div>
    </div>
  );
};

export default SliderCard;
